import state from './state.js'
import router from '../router/store.js'
import api from '../api/index.js';
import { serializeState } from './utility-storage.js'

/**
 * State observer
 * updates remove storage on path change
 */
let _remoteStorageTimeout = null;
let _lastRemoteStorageValue = null;

export const updateRemoteStorage = (delay = 200) => {
  clearTimeout(_remoteStorageTimeout)
  if (router.lastAvailablePath === '/') return;
  _remoteStorageTimeout = setTimeout(async () => {
    const value = serializeState().serialized;
    if (value === _lastRemoteStorageValue) return;
    _lastRemoteStorageValue = value;
    const {resultsId} = await api.update(value)
    if (resultsId) state.set({resultsId})
  }, delay)
}
